module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('n-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHeader),
      expression: "showHeader"
    }],
    ref: "header",
    staticClass: "main-header",
    on: {
      "search": _vm.handelSearch,
      "change": _vm.searchChange,
      "clear": _vm.searchClear,
      "topup": _vm.topup
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-983bf680"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/NIMain.vue
// module id = 496
// module chunks = 1